// Premade test templates for quick testing and development

export const testTemplates = [
  {
    id: 'math-quiz-10',
    name: 'Math Quiz (10 Questions)',
    category: 'Mathematics',
    title: 'Basic Mathematics Quiz',
    description: 'Test your knowledge of basic arithmetic and algebra',
    duration: 30,
    passing_score: 60,
    total_marks: 100,
    instructions: 'Answer all questions. Each question carries equal marks. No calculators allowed.',
    questions: [
      {
        question_text: 'What is 15 + 27?',
        question_type: 'multiple_choice',
        options: ['40', '42', '43', '45'],
        correct_answer: 1,
        points: 10,
        order: 0
      },
      {
        question_text: 'What is 8 × 7?',
        question_type: 'multiple_choice',
        options: ['54', '56', '58', '60'],
        correct_answer: 1,
        points: 10,
        order: 1
      },
      {
        question_text: 'What is 100 - 37?',
        question_type: 'multiple_choice',
        options: ['61', '62', '63', '64'],
        correct_answer: 2,
        points: 10,
        order: 2
      },
      {
        question_text: 'What is 144 ÷ 12?',
        question_type: 'multiple_choice',
        options: ['10', '11', '12', '13'],
        correct_answer: 2,
        points: 10,
        order: 3
      },
      {
        question_text: 'What is 5²?',
        question_type: 'multiple_choice',
        options: ['10', '15', '20', '25'],
        correct_answer: 3,
        points: 10,
        order: 4
      },
      {
        question_text: 'What is the value of x in: 2x + 5 = 15?',
        question_type: 'multiple_choice',
        options: ['3', '4', '5', '6'],
        correct_answer: 2,
        points: 10,
        order: 5
      },
      {
        question_text: 'What is 30% of 200?',
        question_type: 'multiple_choice',
        options: ['50', '60', '70', '80'],
        correct_answer: 1,
        points: 10,
        order: 6
      },
      {
        question_text: 'What is the perimeter of a square with side length 8?',
        question_type: 'multiple_choice',
        options: ['24', '28', '32', '36'],
        correct_answer: 2,
        points: 10,
        order: 7
      },
      {
        question_text: 'What is √64?',
        question_type: 'multiple_choice',
        options: ['6', '7', '8', '9'],
        correct_answer: 2,
        points: 10,
        order: 8
      },
      {
        question_text: 'What is 3/4 as a decimal?',
        question_type: 'multiple_choice',
        options: ['0.25', '0.50', '0.75', '1.00'],
        correct_answer: 2,
        points: 10,
        order: 9
      }
    ]
  },
  {
    id: 'science-quiz-20',
    name: 'Science Quiz (20 Questions)',
    category: 'Science',
    title: 'General Science Knowledge Test',
    description: 'A comprehensive test covering biology, chemistry, and physics basics',
    duration: 45,
    passing_score: 60,
    total_marks: 100,
    instructions: 'Read each question carefully. Select the most appropriate answer.',
    questions: [
      {
        question_text: 'What is the chemical symbol for water?',
        question_type: 'multiple_choice',
        options: ['H2O', 'O2', 'CO2', 'H2O2'],
        correct_answer: 0,
        points: 5,
        order: 0
      },
      {
        question_text: 'How many planets are in our solar system?',
        question_type: 'multiple_choice',
        options: ['7', '8', '9', '10'],
        correct_answer: 1,
        points: 5,
        order: 1
      },
      {
        question_text: 'What is the powerhouse of the cell?',
        question_type: 'multiple_choice',
        options: ['Nucleus', 'Ribosome', 'Mitochondria', 'Chloroplast'],
        correct_answer: 2,
        points: 5,
        order: 2
      },
      {
        question_text: 'What force keeps us on the ground?',
        question_type: 'multiple_choice',
        options: ['Magnetism', 'Friction', 'Gravity', 'Inertia'],
        correct_answer: 2,
        points: 5,
        order: 3
      },
      {
        question_text: 'What gas do plants absorb from the atmosphere?',
        question_type: 'multiple_choice',
        options: ['Oxygen', 'Nitrogen', 'Carbon Dioxide', 'Hydrogen'],
        correct_answer: 2,
        points: 5,
        order: 4
      },
      {
        question_text: 'What is the speed of light approximately?',
        question_type: 'multiple_choice',
        options: ['300,000 km/s', '30,000 km/s', '3,000 km/s', '300 km/s'],
        correct_answer: 0,
        points: 5,
        order: 5
      },
      {
        question_text: 'What is the largest organ in the human body?',
        question_type: 'multiple_choice',
        options: ['Heart', 'Brain', 'Liver', 'Skin'],
        correct_answer: 3,
        points: 5,
        order: 6
      },
      {
        question_text: 'What is the atomic number of Carbon?',
        question_type: 'multiple_choice',
        options: ['4', '6', '8', '12'],
        correct_answer: 1,
        points: 5,
        order: 7
      },
      {
        question_text: 'What type of blood cells fight infection?',
        question_type: 'multiple_choice',
        options: ['Red blood cells', 'White blood cells', 'Platelets', 'Plasma'],
        correct_answer: 1,
        points: 5,
        order: 8
      },
      {
        question_text: 'What is the boiling point of water at sea level?',
        question_type: 'multiple_choice',
        options: ['90°C', '95°C', '100°C', '105°C'],
        correct_answer: 2,
        points: 5,
        order: 9
      },
      {
        question_text: 'What is photosynthesis?',
        question_type: 'multiple_choice',
        options: ['Plant respiration', 'Plant reproduction', 'Light energy to chemical energy', 'Water absorption'],
        correct_answer: 2,
        points: 5,
        order: 10
      },
      {
        question_text: 'What is the most abundant gas in Earth\'s atmosphere?',
        question_type: 'multiple_choice',
        options: ['Oxygen', 'Carbon Dioxide', 'Nitrogen', 'Argon'],
        correct_answer: 2,
        points: 5,
        order: 11
      },
      {
        question_text: 'What is the center of an atom called?',
        question_type: 'multiple_choice',
        options: ['Electron', 'Proton', 'Neutron', 'Nucleus'],
        correct_answer: 3,
        points: 5,
        order: 12
      },
      {
        question_text: 'What do bees collect from flowers?',
        question_type: 'multiple_choice',
        options: ['Seeds', 'Nectar', 'Leaves', 'Roots'],
        correct_answer: 1,
        points: 5,
        order: 13
      },
      {
        question_text: 'What is the freezing point of water?',
        question_type: 'multiple_choice',
        options: ['-5°C', '0°C', '5°C', '10°C'],
        correct_answer: 1,
        points: 5,
        order: 14
      },
      {
        question_text: 'How many bones are in the adult human body?',
        question_type: 'multiple_choice',
        options: ['186', '206', '226', '246'],
        correct_answer: 1,
        points: 5,
        order: 15
      },
      {
        question_text: 'What is the main gas in the Sun?',
        question_type: 'multiple_choice',
        options: ['Oxygen', 'Helium', 'Hydrogen', 'Nitrogen'],
        correct_answer: 2,
        points: 5,
        order: 16
      },
      {
        question_text: 'What is the pH of pure water?',
        question_type: 'multiple_choice',
        options: ['5', '6', '7', '8'],
        correct_answer: 2,
        points: 5,
        order: 17
      },
      {
        question_text: 'What type of energy does a battery store?',
        question_type: 'multiple_choice',
        options: ['Kinetic', 'Thermal', 'Chemical', 'Nuclear'],
        correct_answer: 2,
        points: 5,
        order: 18
      },
      {
        question_text: 'What is the study of weather called?',
        question_type: 'multiple_choice',
        options: ['Geology', 'Biology', 'Meteorology', 'Astronomy'],
        correct_answer: 2,
        points: 5,
        order: 19
      }
    ]
  },
  {
    id: 'true-false-10',
    name: 'True/False Challenge (10 Questions)',
    category: 'General Knowledge',
    title: 'True or False Quiz',
    description: 'Test your knowledge with these true or false questions',
    duration: 15,
    passing_score: 70,
    total_marks: 100,
    instructions: 'Read each statement carefully and decide if it is True or False.',
    questions: [
      {
        question_text: 'The Earth revolves around the Sun.',
        question_type: 'true_false',
        options: ['True', 'False'],
        correct_answer: 0,
        points: 10,
        order: 0
      },
      {
        question_text: 'Water boils at 90°C at sea level.',
        question_type: 'true_false',
        options: ['True', 'False'],
        correct_answer: 1,
        points: 10,
        order: 1
      },
      {
        question_text: 'Humans have five senses.',
        question_type: 'true_false',
        options: ['True', 'False'],
        correct_answer: 0,
        points: 10,
        order: 2
      },
      {
        question_text: 'The Great Wall of China is visible from space.',
        question_type: 'true_false',
        options: ['True', 'False'],
        correct_answer: 1,
        points: 10,
        order: 3
      },
      {
        question_text: 'Lightning is hotter than the surface of the Sun.',
        question_type: 'true_false',
        options: ['True', 'False'],
        correct_answer: 0,
        points: 10,
        order: 4
      },
      {
        question_text: 'Sharks are mammals.',
        question_type: 'true_false',
        options: ['True', 'False'],
        correct_answer: 1,
        points: 10,
        order: 5
      },
      {
        question_text: 'Mount Everest is the tallest mountain in the world.',
        question_type: 'true_false',
        options: ['True', 'False'],
        correct_answer: 0,
        points: 10,
        order: 6
      },
      {
        question_text: 'Diamonds are made from compressed coal.',
        question_type: 'true_false',
        options: ['True', 'False'],
        correct_answer: 1,
        points: 10,
        order: 7
      },
      {
        question_text: 'The human body has four chambers in the heart.',
        question_type: 'true_false',
        options: ['True', 'False'],
        correct_answer: 0,
        points: 10,
        order: 8
      },
      {
        question_text: 'Sound travels faster than light.',
        question_type: 'true_false',
        options: ['True', 'False'],
        correct_answer: 1,
        points: 10,
        order: 9
      }
    ]
  },
  {
    id: 'programming-basics-15',
    name: 'Programming Basics (15 Questions)',
    category: 'Computer Science',
    title: 'Introduction to Programming',
    description: 'Test your understanding of basic programming concepts',
    duration: 40,
    passing_score: 60,
    total_marks: 100,
    instructions: 'Answer all questions about programming fundamentals.',
    questions: [
      {
        question_text: 'What does HTML stand for?',
        question_type: 'multiple_choice',
        options: ['Hyper Text Markup Language', 'High Tech Modern Language', 'Home Tool Markup Language', 'Hyperlinks and Text Markup Language'],
        correct_answer: 0,
        points: 7,
        order: 0
      },
      {
        question_text: 'Which of these is a programming language?',
        question_type: 'multiple_choice',
        options: ['HTML', 'CSS', 'Python', 'XML'],
        correct_answer: 2,
        points: 7,
        order: 1
      },
      {
        question_text: 'What is a variable in programming?',
        question_type: 'multiple_choice',
        options: ['A constant value', 'A container for storing data', 'A function', 'A loop'],
        correct_answer: 1,
        points: 7,
        order: 2
      },
      {
        question_text: 'What does CPU stand for?',
        question_type: 'multiple_choice',
        options: ['Central Process Unit', 'Computer Personal Unit', 'Central Processing Unit', 'Central Processor Unity'],
        correct_answer: 2,
        points: 7,
        order: 3
      },
      {
        question_text: 'Which symbol is used for comments in Python?',
        question_type: 'multiple_choice',
        options: ['//', '/* */', '#', '<!--'],
        correct_answer: 2,
        points: 6,
        order: 4
      },
      {
        question_text: 'What is a loop used for in programming?',
        question_type: 'multiple_choice',
        options: ['Storing data', 'Repeating code', 'Declaring variables', 'Creating functions'],
        correct_answer: 1,
        points: 6,
        order: 5
      },
      {
        question_text: 'What does SQL stand for?',
        question_type: 'multiple_choice',
        options: ['Structured Query Language', 'Simple Query Language', 'Standard Question Language', 'System Query Logic'],
        correct_answer: 0,
        points: 7,
        order: 6
      },
      {
        question_text: 'What is an array?',
        question_type: 'multiple_choice',
        options: ['A single variable', 'A collection of variables', 'A function', 'A class'],
        correct_answer: 1,
        points: 6,
        order: 7
      },
      {
        question_text: 'What is debugging?',
        question_type: 'multiple_choice',
        options: ['Writing code', 'Testing code', 'Finding and fixing errors', 'Deploying code'],
        correct_answer: 2,
        points: 7,
        order: 8
      },
      {
        question_text: 'What does API stand for?',
        question_type: 'multiple_choice',
        options: ['Application Programming Interface', 'Advanced Programming Interface', 'Application Process Integration', 'Advanced Process Interface'],
        correct_answer: 0,
        points: 7,
        order: 9
      },
      {
        question_text: 'Which data type stores whole numbers?',
        question_type: 'multiple_choice',
        options: ['Float', 'String', 'Integer', 'Boolean'],
        correct_answer: 2,
        points: 6,
        order: 10
      },
      {
        question_text: 'What is Git used for?',
        question_type: 'multiple_choice',
        options: ['Web design', 'Version control', 'Database management', 'Video editing'],
        correct_answer: 1,
        points: 7,
        order: 11
      },
      {
        question_text: 'What does CSS control?',
        question_type: 'multiple_choice',
        options: ['Logic', 'Styling', 'Database', 'Server'],
        correct_answer: 1,
        points: 7,
        order: 12
      },
      {
        question_text: 'What is a function?',
        question_type: 'multiple_choice',
        options: ['A reusable block of code', 'A variable', 'A data type', 'A loop'],
        correct_answer: 0,
        points: 6,
        order: 13
      },
      {
        question_text: 'What does IDE stand for?',
        question_type: 'multiple_choice',
        options: ['Integrated Development Environment', 'Internet Development Environment', 'Internal Development Engine', 'Integrated Design Environment'],
        correct_answer: 0,
        points: 6,
        order: 14
      }
    ]
  },
  {
    id: 'demo-test',
    name: 'Demo Test (10 Questions)',
    category: 'Demo',
    title: 'Development Testing Demo',
    description: 'A quick demo test for development and testing purposes',
    duration: 20,
    passing_score: 50,
    total_marks: 100,
    instructions: 'This is a demo test with mixed question types for testing purposes.',
    questions: [
      {
        question_text: 'What is 2 + 2?',
        question_type: 'multiple_choice',
        options: ['2', '3', '4', '5'],
        correct_answer: 2,
        points: 10,
        order: 0
      },
      {
        question_text: 'The sky is blue.',
        question_type: 'true_false',
        options: ['True', 'False'],
        correct_answer: 0,
        points: 10,
        order: 1
      },
      {
        question_text: 'What is the capital of France?',
        question_type: 'multiple_choice',
        options: ['London', 'Berlin', 'Paris', 'Madrid'],
        correct_answer: 2,
        points: 10,
        order: 2
      },
      {
        question_text: 'Fish can breathe underwater.',
        question_type: 'true_false',
        options: ['True', 'False'],
        correct_answer: 0,
        points: 10,
        order: 3
      },
      {
        question_text: 'How many days are in a week?',
        question_type: 'multiple_choice',
        options: ['5', '6', '7', '8'],
        correct_answer: 2,
        points: 10,
        order: 4
      },
      {
        question_text: 'The Earth is flat.',
        question_type: 'true_false',
        options: ['True', 'False'],
        correct_answer: 1,
        points: 10,
        order: 5
      },
      {
        question_text: 'What color do you get when you mix red and blue?',
        question_type: 'multiple_choice',
        options: ['Green', 'Purple', 'Orange', 'Yellow'],
        correct_answer: 1,
        points: 10,
        order: 6
      },
      {
        question_text: 'Humans need oxygen to survive.',
        question_type: 'true_false',
        options: ['True', 'False'],
        correct_answer: 0,
        points: 10,
        order: 7
      },
      {
        question_text: 'How many continents are there?',
        question_type: 'multiple_choice',
        options: ['5', '6', '7', '8'],
        correct_answer: 2,
        points: 10,
        order: 8
      },
      {
        question_text: 'The sun rises in the west.',
        question_type: 'true_false',
        options: ['True', 'False'],
        correct_answer: 1,
        points: 10,
        order: 9
      }
    ]
  }
]

export const getTemplateById = (id) => {
  return testTemplates.find(template => template.id === id)
}

export const getTemplatesByCategory = (category) => {
  return testTemplates.filter(template => template.category === category)
}

export default testTemplates

